import { UserRoleType } from '~/enums/UserRoleType';
import { User } from '~/types/User';

export const testHasRole =
  (role: UserRoleType) =>
  (user: User): boolean => {
    return user.role === role;
  };
